export const smartRound = (n: number, decimalPlaces: number = 2): number => {
  const [_, fraction] = n.toString().split('.')

  if (!fraction) return n
  if (fraction.length > decimalPlaces) {
    return Number(n.toFixed(decimalPlaces))
  }
  return n
}
